export const appList = [
  { id: 1, name: 'Điều hành số liệu' },
  { id: 2, name: 'Khách hàng và dịch vụ' },
  { id: 1, name: 'Quản lý tài sản', url: import.meta.env.VITE_WP_ASM_URL },
  { id: 1, name: 'Vận hành sản xuất', url: import.meta.env.VITE_WP_WTPM_URL }
]
